/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const coins_2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.467 3.538c0 1.031-1.672 1.867-3.734 1.867C2.671 5.405 1 4.569 1 3.538m7.467 0c0-1.03-1.672-1.867-3.734-1.867C2.671 1.671 1 2.507 1 3.538m7.467 0V6.5M1 3.538V12.2c0 .986 1.53 1.794 3.97 1.862M1 6.405C1 7.39 2.53 8.202 4.97 8.27M1 9.39c0 .986 1.53 1.792 3.97 1.86M15 10.133C15 11.164 13.329 12 11.267 12c-2.062 0-3.734-.836-3.734-1.867m7.467 0c0-1.03-1.671-1.866-3.733-1.866-2.062 0-3.734.835-3.734 1.866m7.467 0v3C15 14.164 13.329 15 11.267 15c-2.062 0-3.734-.836-3.734-1.867v-3"
    />
  </svg>
)
export default coins_2
